import WidgetSkeleton from "./WidgetSkeleton";
import WidgetDataLabel from "./WidgetDataLabel";
import WidgetMessage, { BaseWidgetMessages } from "./WidgetMessage";
import { Card, Col } from "react-bootstrap"
import { ThemedSpan } from "../../../components/utilities";
import { ProfileIconWithId } from "../../../components/ProfileIcon";
import { useReportsSummaryData } from "../hooks/ReportsSummaryContext";
import { toCommas } from "../../../helpers/numbers";

const WidgetBody = ({ isAuthorColumnAvailable }) => {
    const { data, error } = useReportsSummaryData();

    if (error) {
        return <WidgetMessage icon={['fas', 'exclamation']} message={BaseWidgetMessages.Error} />
    }

    if (!data || data.length < 1) {
        return <WidgetMessage message={BaseWidgetMessages.NoResult} />
    }

    return (
        <>
            <WidgetDataLabel 
                label={'Await Author'} 
                includeCenter={isAuthorColumnAvailable}
                centerValue={toCommas(data.reportsSummaryAsAuthor?.awaitAuthor)}
                value={toCommas(data.awaitAuthor)}
            />
            <WidgetDataLabel 
                label={'Author Assigned'} 
                includeCenter={isAuthorColumnAvailable}
                centerValue={toCommas(data.reportsSummaryAsAuthor?.authorAssigned)}
                value={toCommas(data.authorAssigned)}
            />
            <WidgetDataLabel 
                label={'Await Feedback'}
                includeCenter={isAuthorColumnAvailable}
                centerValue={toCommas(data.reportsSummaryAsAuthor?.awaitFeedback)}
                value={toCommas(data.awaitFeedback)}
            />
            <WidgetDataLabel 
                label={'Await Compliance'} 
                includeCenter={isAuthorColumnAvailable}
                centerValue={toCommas(data.reportsSummaryAsAuthor?.awaitComplianceTotal)}
                value={toCommas(data.awaitComplianceTotal)}    
            />
            <WidgetDataLabel 
                label={'Give Feedback'} 
                includeCenter={isAuthorColumnAvailable}
                centerValue={toCommas(data.reportsSummaryAsAuthor?.giveFeedback)}
                value={toCommas(data.giveFeedback)}
            />
            <WidgetDataLabel 
                label={'Rejected'} 
                includeCenter={isAuthorColumnAvailable}
                centerValue={toCommas(data.reportsSummaryAsAuthor?.rejected)}
                value={toCommas(data.rejected)}
            />
            <WidgetDataLabel 
                label={'Compliant'} 
                includeCenter={isAuthorColumnAvailable}
                centerValue={toCommas(data.reportsSummaryAsAuthor?.compliant)}
                value={toCommas(data.compliant)}
            />
        </>
    );
}

export const ReportsWidget = ({ authorId = null }) => {
    const { data, isFetching, isLoading } = useReportsSummaryData();
    const isAuthorColumnAvailable = authorId !== null && data?.reportsSummaryAsAuthor !== null;

    if (isFetching || isLoading) {
        return <WidgetSkeleton />
    }

    return (
        <Col xs={12} sm={12} md={6} lg={6} xl={4}>
             <a className="text-reset text-decoration-none" href={"/management/reports/detailed"}>
                <Card className="overflow-hidden" style={{ height: "300px", color: "dodgerblue" }}>
                    <Card.Body>
                        <Card.Title className="row pb-2">
                            <div className="col-6">
                                <ThemedSpan variant="primary" className="fw-bold">Reports</ThemedSpan>
                            </div>
                            {isAuthorColumnAvailable && (
                                <>
                                    <div className="col-3 d-flex justify-content-center align-items-center">
                                        <ProfileIconWithId userId={authorId} />
                                    </div>
                                    <div className="col-3">&nbsp;</div>
                                </>
                            )}
                        </Card.Title>
                        <Card.Text as="div" className="row g-2">
                            <WidgetBody isAuthorColumnAvailable={isAuthorColumnAvailable} />
                        </Card.Text>
                    </Card.Body>
                </Card>
            </a>
        </Col>
    );
}

// d-flex align-content-center pb-2